import React, { useState, useEffect } from "react";

const ZoomControls = () => {
  const [zoom, setZoom] = useState(100);

  const zoomIn = () => setZoom((prev) => Math.min(prev + 10, 160));
  const zoomOut = () => setZoom((prev) => Math.max(prev - 10, 70));
  const resetZoom = () => setZoom(100);

  useEffect(() => {
    document.body.style.zoom = `${zoom}%`;
    return () => {
      document.body.style.zoom = "100%";
    };
  }, [zoom]);

  return (
    <div
      className="d-flex align-items-center gap-2 px-2 py-1 bg-light border rounded-pill"
      style={{
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(8px)",
        border: "1px solid #dee2e6",
      }}
    >
      <button
        onClick={zoomOut}
        className="btn btn-sm btn-light border-0 p-1"
        title="Zoom Out"
      >
        <i className="bi bi-dash-lg"></i>
      </button>

      <span
        className="fw-semibold text-dark px-2"
        style={{ minWidth: "50px", textAlign: "center", fontSize: "14px" }}
      >
        {zoom}%
      </span>

      <button
        onClick={zoomIn}
        className="btn btn-sm btn-light border-0 p-1"
        title="Zoom In"
      >
        <i className="bi bi-plus-lg"></i>
      </button>

      {zoom !== 100 && (
        <button
          onClick={resetZoom}
          className="btn btn-sm btn-outline-secondary border-0 p-1 ms-1"
          title="Reset Zoom"
        >
          <i className="bi bi-arrow-counterclockwise"></i>
        </button>
      )}
    </div>
  );
};

export default ZoomControls;
